var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row", staticStyle: { "margin-bottom": "5px" } },
    [
      _c(
        "label",
        {
          staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5 control-label",
          attrs: { for: "timesheet_day_time_start" }
        },
        [_vm._v("\n    " + _vm._s(_vm.fieldLabel) + ": \n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7" },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              [
                _vm.fieldType == "text"
                  ? _c("timesheet-field-text", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "textarea"
                  ? _c("timesheet-field-text-area", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "time"
                  ? _c("timesheet-field-time", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "date"
                  ? _c("timesheet-field-date", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "duration"
                  ? _c("timesheet-field-duration", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "duration_total"
                  ? _c("timesheet-field-duration-total", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "dropdown"
                  ? _c("timesheet-field-dropdown", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm.fieldType == "multistate"
                  ? _c("timesheet-field-multistate", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.fieldType == "dropdown_hours"
                  ? _c("timesheet-field-dropdown-hours", {
                      attrs: {
                        layout: _vm.layoutData,
                        value: _vm.value,
                        index: _vm.index
                      },
                      on: { change: _vm.onChange }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { "padding-left": "5px" } }, [
              _vm.showAddButton
                ? _c(
                    "button",
                    {
                      staticClass: "btn green-jungle",
                      on: { click: _vm.addClick }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showRemoveButton
                ? _c(
                    "button",
                    { staticClass: "btn red", on: { click: _vm.removeClick } },
                    [_c("i", { staticClass: "fa fa-times" })]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.errors, function(error) {
            return _c("div", [
              _c("span", { staticClass: "font-red" }, [_vm._v(_vm._s(error))])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }